import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const ConfirmPassword: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="confirm_password"
      label={t("confirm_password")}
      dependencies={["new_password"]}
      rules={[
        {
          required: true,
          message: t("Confirm Password Required"),
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const oldPassword = getFieldValue("oldPassword");
            const new_password = getFieldValue("new_password");
            if (!value) {
              return Promise.reject(new Error(t("Confirm Password Required")));
            } else if (value !== new_password) {
              return Promise.reject(new Error(t("passwords_not_match")));
            } else if (value === oldPassword) {
              return Promise.reject(
                new Error(t("confirm_password_cannot_be_old_password"))
              );
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input.Password />
    </Form.Item>
  );
};

export default ConfirmPassword;
